<template>
  <boxwrap class="user-details--inner">
    <boxwrap-header>
      <boxwrap-header-items class="user-detail-title">
        <i class="ico--users"></i>
        <span>user detail info</span>
        <button
          class="btn--modify"
          v-if="showUpdate"
          @click="update()"
        >
          <i class="ico--save"></i>
        </button>
        <button
          class="btn--delete"
          v-if="!user.deleted_at"
          @click="del()"
        >
          <i class="ico--delete"></i>
        </button>
        <button
          class="btn--modify"
          v-if="user.deleted_at"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>
      </boxwrap-header-items>

      <boxwrap-header-items class="date-info">
        <div class="date-info--inner">
          <div class="date-info-items">
            <span class="date-info-lbl">created date</span>
            <span class="date-info-date">{{user.created_at | date}}</span>
          </div>

          <div class="date-info-items">
            <span class="date-info-lbl">last login</span>
            <span class="date-info-date" v-if="user.last_login">{{user.last_login | date}}</span>
            <span class="date-info-date" v-else>-  00:00:00</span>
          </div>
          <div class="date-info-items">
            <span class="date-info-lbl">updated at</span>
            <span class="date-info-date" v-if="user.updated_at">{{user.updated_at | date}}</span>
            <span class="date-info-date" v-else>-  00:00:00</span>
          </div>
        </div>
      </boxwrap-header-items>
    </boxwrap-header>

    <boxwrap-contents>
      <boxwrap-items class="user-details-info">
        <div class="details">
          <div class="detail-items -referral">
            <div class="detail-lbl">
              <span>referral</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span v-if="user.referrer">{{user.referrer.login_id}}</span>
                <span v-else>n/a</span>
              </div>

              <button class="btn--info"  @click="openUserPopup()">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -code -single">
            <div class="detail-lbl">
              <span>code</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner" v-if="user.code">
                <span>{{user.code.code}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -agent">
            <div class="detail-lbl">
              <span>agent</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner" v-if="user.code">
                <span>{{user.code.agent_id}}</span>
              </div>

              <button class="btn--info"  @click="openAgentPopup()">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -login-id -single">
            <div class="detail-lbl">
              <span>login id</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.login_id }}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -login-name -single">
            <div class="detail-lbl">
              <span>login name</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.login_name }}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -level">
            <div class="detail-lbl">
              <span>level</span>
            </div>
            <div
              class="detail-data"
              :class="{ '-disabled' : !checkPermission }"
              v-if="user.level"
            >
              <select-list
                :title="user.level.name"
                :withReset="true"
                v-model="user.level_id"
                v-if="checkPermission"
              >
                <select-option
                  v-for="level in levels"
                  :value="level.id"
                  :key="level.id"
                  :name="level.name"
                  @click.native="setUpdate()"
                >
                  {{ level.name }}
                </select-option>
              </select-list>

              <div
                class="detail-data--inner"
                v-else
              >
                <span>{{ user.level.name }}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -phone">
            <div class="detail-lbl">
              <span>phone</span>
            </div>
            <div
              class="detail-data"
              :class="{ '-disabled' : !checkPermission }"
            >
              <!-- <div
                class="input-wrap"
                v-if="checkPermission"
              >
                <input
                  type="text"
                  :placeholder="user.phone"
                  v-model="user.phone"
                />
              </div> -->

              <div
                class="detail-data--inner"
              >
                <span>{{ user.phone }}</span>
              </div>

              <button
                class="btn--edit"
                @click="showPhone=true"
              >
                <i class="ico--edit"></i>
              </button>

              <!-- <button
                class="btn--info"
                v-if="checkPermission"
                @click="update()"
              >
                <i class="ico--save"></i>
              </button> -->
            </div>
          </div>

          <div class="detail-items -password">
            <div class="detail-lbl">
              <span>password</span>
            </div>
            <div
              class="detail-data"
              :class="{ '-disabled' : !changePass }"
            >
              <div
                class="detail-data--inner"

              >
                <span>{{ showPassword }}</span>
              </div>
              <!-- <div
                class="detail-data--inner"
                v-if="!changePass"
              >
                <span>{{ showPassword }}</span>
              </div> -->

              <!-- <div
                class="input-wrap"
                v-if="checkPermission && changePass"
              >
                <input
                  :placeholder="newPassword"
                  type="text"
                  v-model="newPassword"
                />
              </div> -->

              <button
                class="btn--edit"
                @click="changePass = true"
                v-if="checkPermission && !changePass"
              >
                <i class="ico--edit"></i>
              </button>

              <button
                class="btn--info"
                @click="update()"
                v-if="checkPermission && changePass"
              >
                <i class="ico--save"></i>
              </button>
            </div>
          </div>

          <div
            class="detail-items -status"
            :class="{'-single': user.deleted_at}"
          >
            <div class="detail-lbl">
              <span>status</span>
            </div>
            <div
              class="detail-data"
              :class="{ '-disabled' : !checkPermission }"
            >
              <select-list
                :title="user.status | status"
                :withReset="true"
                v-model="user.status"
                v-if="checkPermission && user.status && !user.deleted_at"
              >
                <select-option
                  v-for="(stat, x) in stats"
                  :value="stat"
                  :key="stat"
                  :name="stat | status"
                  @click.native="setUpdate()"
                >
                  {{stat | status}}
                </select-option>
              </select-list>

              <div
                class="detail-data--inner"
                v-else
              >
                <span v-if="!user.deleted_at">{{ user.status | status }}</span>
                <span v-else>DELETED</span>
              </div>
            </div>
          </div>

          <div class="detail-items -manual">
            <div class="detail-lbl">
              <span>manual</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input type="text" />
              </div>

              <!-- <button class="btn--info">
                <i class="ico--info"></i>
              </button> -->
            </div>
          </div>

          <div class="detail-items -money">
            <div class="detail-lbl">
              <span>money</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span>{{ user.amount | FormatAmount('whole')}}</span>
                <!-- <input type="text" v-model="user.amount"/> -->
              </div>

              <button
                class="btn--info"
                @click="showCashinOut=true"
              >
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -point">
            <div class="detail-lbl">
              <span>point</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span>{{user.point | FormatAmount('whole')}}</span>
                <!-- <input type="text" v-model="user.amount"/> -->
              </div>

              <button
                class="btn--info"
                @click="showPoint=true"
              >
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -cash-in -single">
            <div class="detail-lbl">
              <span>cash in</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.total_cash_in | FormatAmount('whole')}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -cash-out -single">
            <div class="detail-lbl">
              <span>cash out</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.total_cash_out | FormatAmount('whole')}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -cash-net -single">
            <div class="detail-lbl">
              <span>cash net</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.total_cash_net | FormatAmount('whole')}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -total-betting -single">
            <div class="detail-lbl">
              <span>total betting</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{ user.total_bet | FormatAmount('whole')}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -now-betting -single">
            <div class="detail-lbl">
              <span>now betting</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>

          <div class="detail-items -sports-win -single">
            <div class="detail-lbl">
              <span>sports win</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>

          <div class="detail-items -min-game-win -single">
            <div class="detail-lbl">
              <span>min game win</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </boxwrap-items>

      <boxwrap-items class="user-details-data">
        <user-details-tabs></user-details-tabs>

        <div class="user-details-contents">
          <user-info
            v-if="$route.params.tab === 'info'"
          ></user-info>

          <user-cash-info-history
            v-if="$route.params.tab === 'cash-history'"
          ></user-cash-info-history>

          <user-transaction-history
            ref="transactionHistory"
            v-if="$route.params.tab === 'transaction-history'"
          ></user-transaction-history>

          <user-manual-history
            ref="manualHistory"
            v-if="$route.params.tab === 'manual-history'"
          ></user-manual-history>

          <user-point-history
            ref="pointHistory"
            v-if="$route.params.tab === 'point-history'"
          ></user-point-history>

          <user-bet-history
            v-if="$route.params.tab === 'bet-history'"
          ></user-bet-history>

          <user-help-history
            v-if="$route.params.tab === 'help-history'"
          ></user-help-history>

          <user-message-history
            v-if="$route.params.tab === 'message-history'"
          ></user-message-history>

          <user-refferal-list
            v-if="$route.params.tab === 'referral-list'"
          ></user-refferal-list>
        </div>
      </boxwrap-items>
    </boxwrap-contents>

    <!-- modal for phone -->
    <modal
      class="modal--edit-phone"
      title="modify phone"
      :activate="showPhone"
      v-if="showPhone"
      @activate="showPhone=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current phone</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{user.phone}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>new phone</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  :placeholder="newPhoneNumber"
                  type="text"
                  v-model="newPhoneNumber"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update()"
        >
          <i class="ico--save"></i>
          <span>Save</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for phone -->

    <!-- modal for password -->
    <modal
      class="modal--edit-password"
      title="modify password"
      :activate="changePass"
      v-if="changePass"
      @activate="changePass=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current password</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{showPassword}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>new password</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  type="text"
                  :placeholder="newPassword"
                  v-model="newPassword"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update()"
        >
          <i class="ico--save"></i>
          <span>Save</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for password -->

    <!-- modal for money -->
    <modal
      class="modal--edit-cashinout"
      title="manual cash (deposit/withdraw)"
      :activate="showCashinOut"
      v-if="showCashinOut"
      @activate="showCashinOut=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current balance</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{this.user.amount | FormatAmount}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>amount</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="manualData.amount"
                 />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="createTransact('cashin')"
        >
          <i class="ico--cashin"></i>
          <span>deposit</span>
        </button>

        <button
          class="btn--modify -withlabel"
          @click="createTransact('cashout')"
        >
          <i class="ico--cashout"></i>
          <span>withdraw</span>
        </button>

        <button
          class="btn--delete -withlabel"
          @click="manualData.amount = 0, cashLoad=false"
        >
          <i class="ico--cancel"></i>
          <span>clear</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for money -->

    <!-- modal for point -->
    <modal
      class="modal--edit-cashinout"
      title="manual point (deposit/withdraw)"
      :activate="showPoint"
      v-if="showPoint"
      @activate="showPoint=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current point</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{user.point | FormatAmount('whole')}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>point</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="pointAmt"
                 />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="createPoint('deposit')"
        >
          <i class="ico--cashin"></i>
          <span>deposit</span>
        </button>
        <button
          class="btn--modify -withlabel"
          @click="createPoint('withdraw')"
        >
          <i class="ico--cashout"></i>
          <span>withdraw</span>
        </button>

        <button
          class="btn--delete -withlabel"
          @click="pointAmt = 0, pointsLoad=false"
        >
          <i class="ico--cancel"></i>
          <span>clear</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for point -->
  </boxwrap>
</template>

<script>
import { transfers, points } from '@/socket'
import Pagination from '@/components/base/Pagination'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'

//= components
import Modal from '@/components/base/Modal'
import UserDetailsTabs from '@/components/common/user-details/UserDetailsTabs'

// tabs
import UserInfo from '@/components/common/user-details/UserInfo'
import UserTransactionHistory from '@/components/common/user-details/UserTransactionHistory'
import UserCashInfoHistory from '@/components/common/user-details/UserCashInfoHistory'
import UserManualHistory from '@/components/common/user-details/UserManualHistory'
import UserPointHistory from '@/components/common/user-details/UserPointHistory'
import UserBetHistory from '@/components/common/user-details/UserBetHistory'
import UserHelpHistory from '@/components/common/user-details/UserHelpHistory'
import UserMessageHistory from '@/components/common/user-details/UserMessageHistory'
import UserRefferalList from '@/components/common/user-details/UserRefferalList'
//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

export default {
  name: 'userdetails',

  components: {
    Pagination,
    Modal,
    UserDetailsTabs,
    UserInfo,
    UserCashInfoHistory,
    UserManualHistory,
    UserPointHistory,
    UserBetHistory,
    UserHelpHistory,
    UserMessageHistory,
    UserRefferalList,
    UserTransactionHistory
  },

  mixins: [ swal ],

  computed: {
    ...mapState('user', { u: 'user' }),
    ...mapState('vip', ['vipList']),
    ...mapState('level', ['levels']),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    showPassword () {
      if (this.user.temp) {
        return window.atob(this.user.temp)
      }
    },

    stats (e) {
      let status = []
      switch (this.user.status.toLowerCase()) {
        case 'c':
          status = ['B']
          break
        case 'w':
        case 'p':
          status = ['C', 'R', 'W']
          break
        case 'b':
          status = ['C']
          break
        case 'r':
          status = ['P', 'W']
          break
      }

      return status
    }
  },

  filters: {
    FormatAmount,

    status (stat) {
      if (!stat) return ''
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'd':
          status = 'deleted'
          break
        case 'b':
          status = 'ban'
          break
      }
      return status
    }

  },

  data () {
    let params = Object.assign(
      {
        rows: 5,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    for (const key in params) {
      if (params.hasOwnProperty(key) && !isNaN(parseFloat(params[key]))) {
        params[key] = parseFloat(params[key])
      }
    }

    return {
      params,
      newPassword: '',
      newPhoneNumber: '',
      changePass: false,
      user: {},
      showCreate: false,
      showCashinOut: false,
      showPhone: false,
      showPoint: false,

      isCashin: false,
      amount: 0,

      wallet: {
        bank_account_name: '',
        bank_id: 1,
        currency_id: 1,
        bank_number: '',
        bank_password: ''
      },

      manualData: {
        amount: 0,
        type: 3
      },

      showUpdate: false,

      pointAmt: 0,

      pointsLoad: false,
      cashLoad: false
    }
  },

  async created () {
    transfers.on('cash-in', async (message) => {
      this.find({ id: this.$route.params.id })
    })

    transfers.on('cash-out', async (message) => {
      this.find({ id: this.$route.params.id })
    })

    transfers.on('update-status', async (message) => {
      this.find({ id: this.$route.params.id })
    })

    points.on('convert', (data) => {
      this.find({ id: this.$route.params.id })
    })

    await this.find({ id: this.$route.params.id, params: this.params })

    this.user = Object.assign({}, this.u)
    this.tempPass = this.user.password

    console.log('crash', this.u)

    await this.getVips()
    await this.getLevels()
  },

  watch: {
    u (val) {
      this.user = Object.assign({}, val)
    },
    pointAmt (val) {
      if (!val) return
      let number = val.replace(/[,]/g, '')
      let amount = number.toString().split('.')
      let amountString = number.toString()
      let decimal = []

      amount[0] = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      if (amountString.indexOf('.') != -1) {
        amountString = amountString.split('.')

        if (_.size(amount) > 2) {
          for (let a = _.size(amount); a > 2; a--) {
            amount.pop()
          }
        }
        decimal = amountString[1].split('')
        if (decimal.length > 2) amountString[1] = amountString[1].slice(0, 2)
        amountString[0] = amount[0]
        this.pointAmt = amountString.join('.')
      }

      if (amountString.indexOf('.') == -1) {
        this.pointAmt = amount.join('.')
      }
    },
    'manualData.amount' (val) {
      let number = val.replace(/[,]/g, '')
      let amount = number.toString().split('.')
      let amountString = number.toString()
      let decimal = []

      amount[0] = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      if (amountString.indexOf('.') != -1) {
        amountString = amountString.split('.')

        if (_.size(amount) > 2) {
          for (let a = _.size(amount); a > 2; a--) {
            amount.pop()
          }
        }
        decimal = amountString[1].split('')
        if (decimal.length > 2) amountString[1] = amountString[1].slice(0, 2)
        amountString[0] = amount[0]
        this.manualData.amount = amountString.join('.')
      }

      if (amountString.indexOf('.') == -1) {
        this.manualData.amount = amount.join('.')
      }
    }
  },

  methods: {
    ...mapActions('transfer', { createManual: 'create' }),

    ...mapActions('user', { patch: 'update' }),
    ...mapActions('user', ['find', 'delete']),

    ...mapActions('userWallet', {
      createWallet: 'create',
      updateWallet: 'update'
    }),

    ...mapActions('points', {
      createUserPoints: 'create'
    }),

    ...mapActions('transfer', { transaction: 'create' }),
    ...mapActions('vip', { getVips: 'get' }),
    ...mapActions('level', { getLevels: 'get' }),

    openUserPopup () {
      if (!this.user.referrer) return
      window.open(
        `${process.env.VUE_APP_URL}/user/${this.user.referrer.id}/info/undeleted`,
        '',
        `width=${1200},height=${window.innerHeight}`
      )
    },

    openAgentPopup () {
      window.open(
        `${process.env.VUE_APP_URL}/agent/${this.user.code.aid}/info/undeleted`,
        '',
        `width=${1200},height=${window.innerHeight}`
      )
    },

    async update () {
      await (new Promise((resolve) => {
        this.$alert('prompt', 'Sure?', {}, () => res(true), 'Modify User')
      }))

      if (this.changePass && !this.newPassword) {
        alert('pls enter password')
        return
      }

      let data = {}

      let keys = [
        'login_id',
        'login_name',
        'phone',
        'email',
        'level_id',
        'vip_id',
        'status',
        'deleted_at'
      ]

      if (this.newPhoneNumber) {
        this.user.phone = this.newPhoneNumber
      }

      for (var key in this.user) {
        if (keys.indexOf(key) > -1) {
          data[key] = this.user[key]
        }
      }

      if (this.status !== 'D') {
        this.user.deleted_at = null
      }

      if (this.changePass) {
        data.password = this.newPassword
        data.temp = this.newPassword
        this.user.temp = window.btoa(this.newPassword)
      }

      try {
        await this.patch({ data: data, id: this.$route.params.id, user: this.user })
        this.changePass = false
        this.showPhone = false
        this.$alert('success', 'You have modified user', {}, '', 'Updated')
        await this.find({ id: this.$route.params.id, params: this.params })
      } catch (err) {
        this.user = JSON.parse(JSON.stringify(this.u))
      }
    },

    async setUpdate () {
      this.$nextTick(() => {
        if ((this.user.level_id !== this.u.level_id) ||
          this.user.status !== this.u.status) {
          this.showUpdate = true
        } else {
          this.showUpdate = false
        }
      })
    },

    async del () {
      try {
        await this.delete({ uid: this.$route.params.id, user: this.user })
        this.user.deleted_at = new Date()
        this.user.updated_at = new Date()
        this.$alert('success', 'Deleted', {}, '', 'Deleted')
      } catch (err) {
        this.user = this.u
      }
    },

    async restore () {
      try {
        this.user.deleted_at = null
        this.user.updated_at = new Date()
        await this.patch({
          id: this.$route.params.id,
          data: {
            deleted_at: null
          },
          user: this.user
        })
        this.$alert('success', 'Restored', {}, '', 'Restored')
      } catch (err) {
        this.user = this.u
      }
    },

    async search () {
      await this.getReferrals({ id: this.$route.params.id, params: this.params })
      this.$router.push({ query: this.params })
    }, // search

    async trigger () {

    },

    async createTransact (type) {
      if (parseInt(this.manualData.amount) <= 0) {
        this.$alert('error', 'Make sure amt is not 0', {}, '', 'Error')
        return
      }

      if (this.cashLoad) return
      this.cashLoad = true

      let success = async () => {
        this.manualData.type = type === 'cashout' ? 4 : 3
        this.manualData.amount = typeof this.manualData.amount === 'string'
          ? this.manualData.amount.replaceAll(',', '') : this.manualData.amount

        if (this.user.amount < this.manualData.amount && type === 'cashout') {
          this.$alert('error', 'Not enough money', {}, '', 'Error')
          return
        }

        let data = {
          old_balance: this.user.amount,
          type_id: this.manualData.type,
          user_id: this.user.id,
          status: 'C',
          amount: this.manualData.amount
        }

        try {
          await this.createManual(data)
          this.$alert('success', 'Manual Transaction Done', {}, '', 'Success')
          await this.find({ id: this.$route.params.id, params: this.params })

          this.showCashinOut = false
          this.$router.push({ path: `/user/${this.$route.params.id}/manual-history/all` })

          if (this.$refs.manualHistory) {
            this.$refs.manualHistory.search()
          }
          if (this.$refs.transactionHistory) {
            this.$refs.transactionHistory.search()
          }
        } catch (err) {
          this.$alert('error', 'Cannot Complete Transaction', {}, '', 'Error')
        }

        this.cashLoad = false
      }

      let cancel = () => {
        this.cashLoad = false
      }

      this.$alert('prompt', 'Sure?', {}, { success, cancel }, type)
    },

    async createPoint (type) {
      let amt = typeof this.pointAmt === 'string' ? this.pointAmt.replaceAll(',', '') : this.pointAmt

      if (parseInt(amt) <= 0) {
        this.$alert('error', 'Make sure amt is not 0', {}, '', 'Error')
        return
      }

      if (this.pointsLoad) return
      this.pointsLoad = true
      await (new Promise((resolve) => {
        this.$alert('prompt', 'Sure?', {}, () => res(true), type)
      }))

      if (this.user.point < amt && type === 'withdraw') {
        this.$alert('error', 'Not enough points', {}, '', 'Error')
        return
      }

      if (type === 'withdraw') {
        amt = amt * (-1)
      }

      await this.createUserPoints({
        uid: this.$route.params.id,
        data: amt
      })

      this.$alert('success', 'Manual Point Done', {}, '', 'Success')
      await this.find({ id: this.$route.params.id, params: this.params })

      if (this.$refs.pointHistory) {
        this.$refs.pointHistory.search()
      }

      this.showPoint = false
      this.pointsLoad = false
      this.pointAmt = 0

      this.$router.push({ path: `/user/${this.$route.params.id}/point-history/all` })
    }
  }
}
</script>
